module.exports = __webpack_public_path__ + "static-v-shop/1785357392588/img/logo_master.c8bdcd8d.svg";